import axios from "axios";

const apiRequest = axios.create({
  //正式api
  //baseURL: "https://overseasinterface.taiwanjobs.gov.tw/api/",
  // baseURL: "http://192.168.8.80:8080/api/",
  baseURL: "http://192.168.1.188/oversea/api/",
  // baseURL: "http://localhost/oversea/api/",
  //baseURL: "https://localhost:44398/api/",
  // baseURL: "https://localhost:5001/api/",
});

//中心介紹
export const apiCenterAbout = () => apiRequest.get("Home/center");

//常見問答 - (分類資料)
export const apiQa = (data) => apiRequest.post("Home/qa", data);

//網站導覽
export const apiTour = () => apiRequest.get("Home/tour");

//網站瀏覽人數及更新時間
export const apiWeb = () => apiRequest.get("Home/web");

//聯絡我們
export const apiContact_s = () => apiRequest.get("Contact/select");
export const apiContact = (data) => apiRequest.post("Contact", data);

// 全站搜尋
export const apiSearch = (data) => apiRequest.post("Home", data);

//首頁輪播影片
export const apiBannerSlider = () => apiRequest.get("Home/image");

//最新消息 - (全部)
export const apiNews = (data) => apiRequest.post("News", data);

//最新消息跑馬燈
export const apiNewsMarquee = () => apiRequest.get("News");

//取得海外就業指南
export const apiGuide = () => apiRequest.get("Home/guide");

//('網址'，api要求的資料)

//最新消息 - (單筆)
export const getArticleDataAPI = (pageId) =>
  apiRequest.get(`Home/page/${pageId}`);

//nav選單-國家

export const apiCountry = () => apiRequest.get("Home/country");

//國家
export const apiCountries = (data) => apiRequest.post("Country", data);

//國家共用選單
export const apiMenu = (CountryId) =>
  apiRequest.get(`Country/menu/${CountryId}`);

//國家-熱門國家
export const apiPopularCountry = () => apiRequest.get("Country/popular");

//影音專區 - (國家 - 單筆)
export const apiVideo = (vid) => apiRequest.get(`Home/video/${vid}`);

//海外分享 專家建議 - (全部)
export const apiSeaAdvices = (data) =>
  apiRequest.post(`OverSeaWork/advice`, data);

//取得海外就業分享_影音專區
export const apiVideoShare = (data) =>
  apiRequest.post("OverSeaWork/video", data);

//海外分享 達人投稿 - (全部)
export const apiSeacontributor = (data) =>
  apiRequest.post(`OverSeaWork/contributor`, data);

//海外分享 - 達人投稿 - 發表投稿資訊頁
export const apiContributorInfo = () =>
  apiRequest.get("OverSeaWork/contribute");

//海外分享 - 達人投稿 - 新增一筆達人投稿
export const apiContributorAdd = ({
  CountryId,
  PageTitle,
  PageContent,
  PosterName,
  PostEmail,
  Files,
  Des,
}) => {
  const submitData = new FormData();
  submitData.append("CountryId", CountryId);
  submitData.append("PageTitle", PageTitle);
  submitData.append("PageContent", PageContent);
  submitData.append("PosterName", PosterName);
  submitData.append("PostEmail", PostEmail);
  Files.forEach((file) => {
    submitData.append("Files", file);
  });
  Des.forEach((des) => {
    submitData.append("Des", des);
  });
  return apiRequest.post("Country/contributor", submitData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

//海外返國就業 - (全部)
export const apiReturnWorkWithEmploymentInfo = (data) =>
  apiRequest.post(`ReturnWork`, data);
export const apiReturnWorkEachType = () => apiRequest.get("ReturnWork");

export const getDownloadFileAPI = (fileId) => {
  const url = `File/${fileId}`;
  return apiRequest.get(url, { responseType: "blob" });
};

export const getDownloadItems = () => {
  const url = "Home/download";
  return apiRequest.get(url);
};

//  訂閱
export const getSubscribableOptions = () => {
  const url = "Subscription/Select";
  return apiRequest.get(url);
};
export const getSubscriptionFrequencyOptions = () => {
  const url = "Subscription/Select/Frequency";
  return apiRequest.get(url);
};

export const subscriptInfo = (data) => {
  const url = "Subscription";
  console.log(data);
  return apiRequest.post(url, data);
};

//取得焦點訊息
export const apiFocusNew = () => apiRequest.get("Home/FocusNew");

//紀錄觀看焦點訊息
export const apiFocusNewCount = () => apiRequest.get("Home/FocusNewCount");
